var a = /* @__PURE__ */ ((r) => (r.button = "button", r.callout = "callout", r.preview = "preview", r))(a || {});
export {
  a as StoreItemStyleEnum
};
